<template>
  <div>
    <!-- Loading Summary -->
    <div class="mb-3">
      <ProgressBar
          :percent="(ticketData.loaded / (remainingPassengers.length + loadedPassengers.length)) * 100"
          :total="remainingPassengers.length + loadedPassengers.length"
          :raw="ticketData.loaded"
          heading="Loaded"
      />
      <div class="mt-2"></div>
      <ProgressBar
          :percent="(loadedEquipment / (remainingEquipment + loadedEquipment)) * 100"
          :total="remainingEquipment + loadedEquipment"
          :raw="loadedEquipment"
          heading="Equipment"
      />
    </div>

    <!-- Passenger List -->
    <div class="accordion" id="loadingPaxAccordion">
      <AccordionItem id="loadingRemaining" parent-id="loadingPaxAccordion" expanded>
        <template #header>
          <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
          <span>{{ __DICT__.loadTransferView.remaining }} ({{ remainingPassengers.length }})</span>
        </template>
        <ul class="list-group list-group-flush">
          <li v-for="passenger in remainingPassengers"
              :key="passenger.bookingRef"
              class="list-group-item d-flex justify-content-between align-items-center"
              @click="$emit('openPassengerQuickView', passenger)"
          >
            <div class="d-flex align-items-center">
              <Badge v-if="passenger.equipment" text="E" pill class="me-2"/>
              <span>{{ passenger.name }}</span>
            </div>
            <Badge
                :text="passenger.bookingRef?.split('-')[0] === 'P24' ? 'OTHER' : passenger.bookingRef?.split('-')[0]"
                :variant="{ NUCO: 'red-lt', WASTELAND: 'blue-lt', WHITEROAD: 'black', 'P24': 'purple-lt' }[passenger.bookingRef?.split('-')[0]] ?? 'orange'"
            />
          </li>
        </ul>
      </AccordionItem>

      <AccordionItem id="loadingLoaded" parent-id="loadingPaxAccordion">
        <template #header>
          <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
          <span>{{ __DICT__.loaded }} ({{ loadedPassengers.length }})</span>
        </template>
        <ul class="list-group list-group-flush">
          <li v-for="passenger in loadedPassengers"
              :key="passenger.bookingRef"
              class="list-group-item d-flex justify-content-between align-items-center"
              @click="$emit('openPassengerQuickView', passenger)"
          >
            <div class="d-flex align-items-center">
              <Badge v-if="passenger.equipment" text="E" pill class="me-2"/>
              <span>{{ passenger.name }}</span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <Badge
                  :text="passenger.bookingRef?.split('-')[0] === 'P24' ? 'Other' : passenger.bookingRef?.split('-')[0]"
                  :variant="{ NUCO: 'red-lt', WASTELAND: 'blue-lt', WHITEROAD: 'grey-500', 'P24': 'purple-lt' }[passenger.bookingRef?.split('-')[0]] ?? 'orange'"
              />
              <IconCheck :size="18" class="text-success"/>
            </div>
          </li>
        </ul>
      </AccordionItem>
    </div>

    <div style="height: 100px"></div>
  </div>
</template>

<script setup>
import ProgressBar from "@/components/ProgressBar.vue";
import {AccordionItem, Badge} from "@/components/atomic";
import {IconCheck} from "@tabler/icons-vue";

defineProps({
  ticketData: { type: Object, default: () => ({}) },
  remainingPassengers: { type: Array, default: () => [] },
  loadedPassengers: { type: Array, default: () => [] },
  remainingEquipment: { type: Number, default: 0 },
  loadedEquipment: { type: Number, default: 0 },
});

defineEmits(['openPassengerQuickView']);
</script>
